'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var o, r, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(r = 0; r < i.length; r++)o = i[r], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (n[o] = t[o]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var o, r, n = {}, i = Object.keys(t);
    for(r = 0; r < i.length; r++)o = i[r], e.indexOf(o) >= 0 || (n[o] = t[o]);
    return n;
}
const ListboxOptionThumbnailContainer = renderWithRef('ListboxOptionThumbnailContainer', null, (o, r)=>{
    var { children: n } = o;
    return jsx(RenderComp, {
        root: "div",
        classNames: [
            'swan-listbox-option-thumbnail-container'
        ],
        forwardedRef: r,
        props: _object_without_properties(o, [
            "children"
        ]),
        children: n
    });
});

export { ListboxOptionThumbnailContainer };
